import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { Link, useNavigate } from "react-router-dom";
import "./SupportLayout.css";
import { useState, useEffect } from "react";
import Instance from "../../Utils/Axios";
import { showToast } from "../../Utils/index";
import { supportSchema } from "../../Utils/validationSchema";
import useFormValidation from "../../Hooks/useformValidation";
import Select from "react-select";
import { Controller } from "react-hook-form";

export default function NewTicket() {
  const [ticketData, setTicketData] = useState({
    name: "",
    email: "",
    phone: "",
    isdCode: "",
    countryId: "",
    subject: "",
    description: "",
    hlpReason: "",
  });

  const [countryList, setCountryList] = useState([]);
  const [profile, setProfile] = useState({});
  const navigate = useNavigate();

  const helpList = [
    { id: 1, value: "General" },
    { id: 2, value: "PR related" },
    { id: 3, value: "Credit related" },
    { id: 4, value: "Package related" },
    { id: 5, value: "New publication request" },
    { id: 6, value: "Editorial support" },
    { id: 7, value: "Payment related" },
    { id: 8, value: "Others" },
  ];

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    clearErrors,
  } = useFormValidation(supportSchema);

  const onSubmitForm = () => {
    const token = localStorage.getItem("tokenId");
    Instance.post("/user/support/create", {
      // tokenId: token,
      ...ticketData,
    })
      .then((response) => {
        if (response.data.resCode === "200") {
          showToast("Ticket created successfully", "success", "success");
          setTimeout(() => {
            navigate("/customer/support");
          }, 1000);
        } else {
          console.error("Error:", response.data.resMessage);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTicketData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (value) {
      clearErrors(name);
    }
  };

  const fetchCountryList = () => {
    const token = localStorage.getItem("tokenId");
    Instance.post("/user/common/countryList", {
      // tokenId: token,
      status: "ACTIVE",
    })
      .then((response) => {
        if (response.data.resCode === "200") {
          const filteredCountries = response.data.message.filter(
            (country) => country.countryName.trim() !== ""
          );
          setCountryList(filteredCountries);
        } else {
          console.error(
            "Error fetching countries list:",
            response.data.resMessage
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching countries list:", error);
      });
  };

  const fetchProfileData = () => {
    const token = localStorage.getItem("tokenId");
    Instance.post("/user/profile", { /* tokenId: token */ })
      .then((response) => {
        setProfile(response.data.userProfile || {});
      })
      .catch((error) => {
        console.error("Error fetching profile data", error);
      });
  };

  useEffect(() => {
    fetchProfileData();
    fetchCountryList();
  }, []);

  useEffect(() => {
    if (profile && countryList.length > 0) {
      const matchedCountry = countryList.find(
        (item) => item.isdCode === profile.isdCode
      );

      setTicketData((prev) => ({
        ...prev,
        name: `${profile.firstName || ""} ${profile.lastName || ""}`.trim(),
        email: profile.email || "",
        phone: profile.mobileNumber || "",
        isdCode: profile.isdCode || "",
        countryId: matchedCountry?.countryId || "",
      }));

      // Update react-hook-form values
      setValue("name", `${profile.firstName || ""} ${profile.lastName || ""}`.trim());
      setValue("email", profile.email || "");
      setValue("phone", profile.mobileNumber || "");
      setValue("isdCode", profile.isdCode || "");
    }
  }, [profile, countryList]);

  return (
    <div className="new_ticket_layout">
      <div className="new_ticket_header">
        <h3 className="new_ticket_title">Add New Query</h3>
        <button
          type="button"
          className="new_ticket_back_btn"
          onClick={() => navigate("/customer/support")}
        >
          Back
        </button>
      </div>
      <div className="new_ticket_card">
        <form onSubmit={handleSubmit(onSubmitForm)} noValidate>
          <Row>
            <Col className="custom_col_new_ticket mb-4">
              <Form.Label>Contact Name</Form.Label>
              <Form.Control
                placeholder="Enter text here"
                name="name"
                {...register("name")}
                value={ticketData.name}
                onChange={handleChange}
              />
              {errors.name && <p className="text-danger">{errors.name.message}</p>}
            </Col>
          </Row>

          <Row>
            <Col xs="6" className="custom_col_new_ticket mb-4">
              <Form.Label>Email</Form.Label>
              <Form.Control
                placeholder="Enter text here"
                name="email"
                {...register("email")}
                value={ticketData.email}
                onChange={handleChange}
              />
              {errors.email && <p className="text-danger">{errors.email.message}</p>}
            </Col>

            <Col xs="6" md="2" className="custom_col_new_ticket mb-4">
              <Form.Label>Country Code</Form.Label>
              <Controller
                name="isdCode"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={countryList.map((country) => ({
                      value: country.isdCode,
                      label: country.isdCode,
                      countryCode: country.countryCode,
                      countryId: country.countryId,
                    }))}
                    formatOptionLabel={({ label, countryCode }) => (
                      <div className="d-flex align-items-center">
                        <img
                          src={`https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`}
                          alt=""
                          className="me-2"
                          style={{ width: "20px", height: "auto" }}
                        />
                        <span>{label}</span>
                      </div>
                    )}
                    placeholder="Select"
                    isSearchable
                    classNamePrefix="react-select"
                    value={
                      field.value
                        ? (() => {
                          const selectedOption = countryList.find(
                            (c) => c.isdCode === field.value
                          );
                          return selectedOption
                            ? {
                              value: selectedOption.isdCode,
                              label: selectedOption.isdCode,
                              countryCode: selectedOption.countryCode,
                              countryId: selectedOption.countryId,
                            }
                            : null;
                        })()
                        : null
                    }
                    onChange={(val) => {
                      field.onChange(val.value);
                      setTicketData((prev) => ({
                        ...prev,
                        countryId: val.countryId,
                        isdCode: val.value,
                      }));
                      clearErrors("isdCode");
                    }}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderRadius: "10px",
                        borderColor: state.isFocused ? "#585edb" : "#ced4da",
                        boxShadow: state.isFocused ? "0 0 0 3px rgba(88, 94, 219, 0.1)" : "none",
                        backgroundColor: "#ffffff",
                        "&:hover": {
                          borderColor: "#585edb",
                        },
                        minHeight: "48px",
                        transition: "all 0.2s ease",
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                        borderRadius: "10px",
                        overflow: "hidden",
                        boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "200px",
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isSelected
                          ? "#585edb"
                          : state.isFocused
                            ? "#f1f2fd"
                            : "transparent",
                        color: state.isSelected ? "white" : "#091e42",
                        "&:active": {
                          backgroundColor: "#585edb",
                        },
                      }),
                    }}
                  />
                )}
              />
              {errors.isdCode && (
                <p className="text-danger">{errors.isdCode.message}</p>
              )}
            </Col>

            <Col xs="6" md="4" className="custom_col_new_ticket mb-4">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                placeholder="Enter text here"
                name="phone"
                {...register("phone")}
                value={ticketData.phone}
                onChange={handleChange}
              />
              {errors.phone && <p className="text-danger">{errors.phone.message}</p>}
            </Col>
          </Row>

          <Row>
            <Col className="custom_col_new_ticket mb-4">
              <Form.Label>Subject</Form.Label>
              <Form.Control
                placeholder="Enter text here"
                name="subject"
                {...register("subject")}
                value={ticketData.subject}
                onChange={handleChange}
              />
              {errors.subject && (
                <p className="text-danger">{errors.subject.message}</p>
              )}
            </Col>
          </Row>

          <Row>
            <Col className="custom_col_new_ticket mb-4">
              <Form.Label>How may we help you?</Form.Label>
              <Controller
                name="hlpReason"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={helpList.map((hlp) => ({
                      value: hlp.value,
                      label: hlp.value,
                    }))}
                    placeholder="Select from dropdown"
                    isSearchable={false}
                    classNamePrefix="react-select"
                    value={field.value ? { value: field.value, label: field.value } : null}
                    onChange={(val) => {
                      field.onChange(val.value);
                      setTicketData((prev) => ({ ...prev, hlpReason: val.value }));
                      clearErrors("hlpReason");
                    }}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        borderRadius: "10px",
                        borderColor: state.isFocused ? "#585edb" : "#ced4da",
                        boxShadow: state.isFocused ? "0 0 0 3px rgba(88, 94, 219, 0.1)" : "none",
                        backgroundColor: "#ffffff",
                        "&:hover": {
                          borderColor: "#585edb",
                        },
                        minHeight: "48px",
                        transition: "all 0.2s ease",
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                        borderRadius: "10px",
                        overflow: "hidden",
                        boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "200px",
                      }),
                      option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isSelected
                          ? "#585edb"
                          : state.isFocused
                            ? "#f1f2fd"
                            : "transparent",
                        color: state.isSelected ? "white" : "#091e42",
                        "&:active": {
                          backgroundColor: "#585edb",
                        },
                      }),
                    }}
                  />
                )}
              />
              {errors.hlpReason && (
                <p className="text-danger">{errors.hlpReason.message}</p>
              )}
            </Col>
          </Row>

          <Row>
            <Col className="custom_col_new_ticket mb-4">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Comment Box"
                name="description"
                {...register("description")}
                value={ticketData.description}
                onChange={handleChange}
              />
              {errors.description && (
                <p className="text-danger">{errors.description.message}</p>
              )}
            </Col>
          </Row>

          <div className="ticket_account_buttons">
            <Link to="/customer/support">
              <button type="button" className="ticket_cancel_btn mb-4">
                Cancel
              </button>
            </Link>
            <button type="submit" className="ticket_save_btn mb-4">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
